// extracted by mini-css-extract-plugin
export var externalLink = "_7t-0";
export var internalLinkLabel = "_7t-1";